// theme.headerSticky = (function() {
//   function ScrollSticky(e){
//     // Check if we're on the homepage
//     const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
    
//     // Exit early if not homepage
//     if (!isHomepage) return;
    
//     const headerStickyWrapper = document.querySelector('header');
//     const headerStickyTarget = document.querySelector('.header__sticky');
    
//     if(headerStickyTarget){
//       let headerHeight = headerStickyWrapper.clientHeight;
//       window.addEventListener('scroll', function(){
//         let StickyTargetElement = TopOffset(headerStickyWrapper);
//         let TargetElementTopOffset = StickyTargetElement.top;
//         if(window.scrollY > headerHeight ){
//           headerStickyTarget.classList.add('sticky');
//         } else{
//           headerStickyTarget.classList.remove('sticky');
//         }
//       })
//     }
//   }
//   return ScrollSticky;
// })();


// theme.headerSticky = (function() {
//   function ScrollSticky(e){
//     const headerStickyWrapper = document.querySelector('header');
//     const headerStickyTarget = document.querySelector('.header__sticky');
    
//     if(headerStickyTarget){
//       let headerHeight = headerStickyWrapper.clientHeight;
//       window.addEventListener('scroll', function(){
//         let StickyTargetElement = TopOffset(headerStickyWrapper);
//         let TargetElementTopOffset = StickyTargetElement.top;
//         if(window.scrollY > headerHeight ){
//           headerStickyTarget.classList.add('sticky');
//         } else{
//           headerStickyTarget.classList.remove('sticky');
//         }
//       })
//     }
    
    
//   }
//   return ScrollSticky;
// })();


theme.headerSticky = (function() {
  function ScrollSticky(e){
    // Check if we're on ANY homepage (including language-locale combinations)
    const pathname = window.location.pathname;
    const isHomepage = pathname === '/' || 
                       pathname === '/index' ||
                       pathname.match(/^\/[a-z]{2}(-[a-z]{2})?\/?$/i) || // Matches /nl, /nl/, /nl-nl, /nl-nl/, /en-us, etc.
                       pathname.match(/^\/[a-z]{2}(-[a-z]{2})?\/index$/i); // Matches /nl/index, /nl-nl/index, etc.
    
    // Exit early if not homepage
    if (!isHomepage) return;
    
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    
    if(headerStickyTarget){
      let headerHeight = headerStickyWrapper.clientHeight;
      window.addEventListener('scroll', function(){
        let StickyTargetElement = TopOffset(headerStickyWrapper);
        let TargetElementTopOffset = StickyTargetElement.top;
        if(window.scrollY > headerHeight ){
          headerStickyTarget.classList.add('sticky');
        } else{
          headerStickyTarget.classList.remove('sticky');
        }
      })
    }
  }
  return ScrollSticky;
})();